
import React from 'react';

function Googlemap1(props) {
    return (
        <div >
            <iframe  src={"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3439.7957024070593!2d72.3499411754067!3d30.44189287472591!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3923356d7cc45387%3A0x5aeaa3b70f4fea84!2zU3VwZXIgRHVwZXIg2LPZvtixINqI2YjZvtix!5e0!3m2!1sen!2s!4v1733586246091!5m2!1sen!2s"} 
           allowfullscreen="" loading="lazy" style= {{width:"100%",  height:"500px", border:0, boxShadow:"rgb(0 0 0 / 16%) 0px 3px 6px, rgb(0 0 0 / 23%) 0px 3px 6px" }}></iframe>
        </div>
    );
}


function Googlemap2(props) {
    return (
        <div >
            <iframe  src={"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3436.7985288346013!2d72.6874209754102!3d30.52673557468428!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39232b5712cb5131%3A0xc4ef6be8f317f0e0!2sSuper%20Duper%20Supermarket!5e0!3m2!1sen!2s!4v1733586408632!5m2!1sen!2s"} 
          allowfullscreen="" loading="lazy" style= {{width:"100%",  height:"500px", border:0,  boxShadow:"rgb(0 0 0 / 16%) 0px 3px 6px, rgb(0 0 0 / 23%) 0px 3px 6px" }}></iframe>
        </div>
    );
}

export {Googlemap1, Googlemap2};

